"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DNSRecordRestricted = exports.DNSRecordFeatureWarning = exports.DNSRecordValue = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));

var _Button = _interopRequireDefault(require("../Button"));

var ViewDNSRecordModal = function ViewDNSRecordModal(_ref) {
  var type = _ref.type,
      isOpen = _ref.isOpen,
      isLoading = _ref.isLoading,
      allowDelete = _ref.allowDelete,
      toggle = _ref.toggle,
      warning = _ref.warning,
      children = _ref.children,
      onDelete = _ref.onDelete;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    open: isOpen,
    onClose: function onClose() {
      return isOpen && toggle();
    },
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(Close, {
    onClick: function onClick() {
      return isOpen && toggle();
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-8"
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "text-2xl font-bold text-dark mb-5"
  }, t('settings.customDomain.records.view.header', {
    type: type
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-5"
  }, children, warning), allowDelete && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "warning",
    onClick: onDelete,
    disabled: !allowDelete || isLoading
  }, t('settings.customDomain.records.view.remove'))));
};

var DNSRecordValue = function DNSRecordValue(_ref2) {
  var label = _ref2.label,
      children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex py-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-24 text-light font-bold mr-5"
  }, label, ":"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 text-dark font-bold break-all"
  }, children));
};

exports.DNSRecordValue = DNSRecordValue;

var DNSRecordFeatureWarning = function DNSRecordFeatureWarning() {
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-sm font-bold text-light"
  }, t('settings.customDomain.records.view.featureError.landingPage'));
};

exports.DNSRecordFeatureWarning = DNSRecordFeatureWarning;

var DNSRecordRestricted = function DNSRecordRestricted() {
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation3.t;

  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-sm font-bold text-light"
  }, t('settings.customDomain.records.view.featureError.restricted'));
};

exports.DNSRecordRestricted = DNSRecordRestricted;

var Close = function Close(props) {
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: "absolute top-0 right-0 mt-5 mr-5 p-2 rounded-full cursor-pointer hover:bg-secondary hover:text-primary text-light"
  }, props), /*#__PURE__*/_react["default"].createElement(_Clear["default"], null));
};

var _default = ViewDNSRecordModal;
exports["default"] = _default;
//# sourceMappingURL=ViewDNSRecordModal.js.map